import React from 'react';
import {
  DatabaseOutlined,
  ImportOutlined,
  ReconciliationOutlined,
} from '@ant-design/icons';
import { Col, Flex, Row } from 'antd';

import GlobalContactsContainer from '@totem/components/administration/globalContacts/GlobalContactsContainer';
import { GlobalContactsContent } from '@totem/components/administration/globalContacts/GlobalContactsPage';
import StorageReportContainer from '@totem/components/administration/storageReporting/StorageReportContainer';
import {
  StorageReportExtra,
  StorageReportLayout,
} from '@totem/components/administration/storageReporting/StorageReportLayout';
import CountBadge from '@totem/components/deviceTypes/CountBadge';
import DeviceTypeContainer from '@totem/components/deviceTypes/DeviceTypeContainer';
import DeviceTypeFilters from '@totem/components/deviceTypes/DeviceTypeFilter';
import DeviceTypeTable from '@totem/components/deviceTypes/DeviceTypeTable';
import MergeButton from '@totem/components/deviceTypes/MergeButton';
import SoftwarePanel from '@totem/components/software/software_report/softwarePanel';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import VendorContainer from '@totem/components/vendors/VendorContainer';
import VendorFilters from '@totem/components/vendors/VendorFilters';
import VendorTable from '@totem/components/vendors/VendorTable';
import { UserProfile } from '@totem/types/user';

export const getMenuAdminDataManagement = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: 'deviceTypes',
      title: 'Device Types',
      label: 'Device Types',
      description: 'Manage Device Types',
      route: '/dashboard/deviceTypes',
      content: (
        <DeviceTypeContainer>
          <IBCard isCovered>
            <DeviceTypeFilters />
            <br />
            <Row>
              <Col span={12}>
                <Flex justify={'flex-start'} align={'center'}>
                  <MergeButton isPrimary />
                </Flex>
              </Col>
              <Col span={12}>
                <Flex justify={'flex-end'} align={'center'}>
                  <CountBadge />
                </Flex>
              </Col>
            </Row>
            <br />
            <DeviceTypeTable />
          </IBCard>
        </DeviceTypeContainer>
      ),
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'globalContacts',
      title: 'Global Contacts',
      label: 'Global Contacts',
      description: 'Global Contact Administration',
      route: '/dashboard/admin/globalContacts',
      content: (
        <GlobalContactsContainer>
          <GlobalContactsContent />
        </GlobalContactsContainer>
      ),
      icon: <ReconciliationOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministratorIBOrg.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'organizationManagement',
      title: 'Org Mgmt',
      label: 'Org Mgmt',
      description: 'Organizations Management',
      route: '/dashboard/organizationManagement',
      icon: <ReconciliationOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministratorIBOrg.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'software',
      title: 'Software',
      label: 'Software',
      description: 'Manage Software Packages',
      route: '/dashboard/software',
      content: <SoftwarePanel />,
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'vendors',
      title: 'Vendors',
      label: 'Vendors',
      description: 'Manage Vendors',
      route: '/dashboard/vendors',
      content: (
        <VendorContainer>
          <IBCard isCovered>
            <VendorFilters />
            <br />
            <Row>
              <Col span={12}>
                <Flex justify={'flex-start'} align={'center'}>
                  <MergeButton isPrimary />
                </Flex>
              </Col>
              <Col span={12}>
                <Flex justify={'flex-end'} align={'center'}>
                  <CountBadge />
                </Flex>
              </Col>
            </Row>
            <br />
            <VendorTable />
          </IBCard>
        </VendorContainer>
      ),
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
